import { useMemo } from "react";
import qrcode from "../services/qrcode-generator";

// نمایش QR کد به‌صورت SVG (بدون هیچ سرویس بیرونی؛ راز 2FA از مرورگر خارج نمی‌شود)
export default function QrCode({ value, size = 180 }: { value: string; size?: number }) {
  const data = useMemo(() => {
    try {
      const qr = qrcode(0, "M");
      qr.addData(value);
      qr.make();
      const n = qr.getModuleCount();
      const cells: string[] = [];
      for (let r = 0; r < n; r++) {
        for (let c = 0; c < n; c++) {
          if (qr.isDark(r, c)) cells.push(`M${c},${r}h1v1h-1z`);
        }
      }
      return { n, path: cells.join("") };
    } catch {
      return null;
    }
  }, [value]);
  if (!data) return null;
  const m = 3; // حاشیه سفید
  const vb = data.n + m * 2;
  return (
    <svg width={size} height={size} viewBox={`${-m} ${-m} ${vb} ${vb}`} shapeRendering="crispEdges" style={{ background: "#fff", borderRadius: 12, padding: 6, display: "block" }} role="img" aria-label="QR">
      <path d={data.path} fill="#0b1020" />
    </svg>
  );
}
